/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceTenantSummaryRequest {
    getFixupPrototypeFunction() { return ComplianceTenantSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceTenantSummaryRequest>): ComplianceTenantSummaryRequest {
        let obj = Object.assign(new ComplianceTenantSummaryRequest(), model);
        ComplianceTenantSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceTenantSummaryRequest>): ComplianceTenantSummaryRequest {
        if (!model) return null;
        return ComplianceTenantSummaryRequest.newInstance(<ComplianceTenantSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceTenantSummaryRequest) {
        if (!obj) return;

        models.ComplianceTenantSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceTenantSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceTenantSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Query based on Tenant IDs, Cloud Providers, Cloud Account Ids, Compliance URIs and Duration
     */
    filters: models.QueryOperator;

}
